import { gql } from '__generated__';

export default gql(`
  query GetTeamTypes(
    $project_id: ID!,
    $event_id: ID!,
  ) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        team_types {
          id
          title
        }
      }
    }
  }
`);
